import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref } from "vue";
import { pb } from "@/pocketbase";
import Heading from "@/components/Heading.vue";
import Success from "@/components/Success.vue";
import router from "@/router";


export default /*@__PURE__*/_defineComponent({
  __name: 'VerifyEmailView',
  setup(__props) {

const user: { email: string, name: string } = pb.authStore.model;
const isMailSent = ref(false);

function resendMail() {
  pb.collection('users').requestVerification(user.email);
  isMailSent.value = true
}

async function reload() {
  await pb.collection('users').authRefresh();
  await router.push('/');
}

pb.collection('users').subscribe(pb.authStore.model.id, (e) => {
  if (e.record?.verified) {
    reload();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Heading, null, {
      default: _withCtx(() => [
        _createTextVNode("Hey " + _toDisplayString(_unref(user).name) + ",", 1)
      ]),
      _: 1
    }),
    _cache[4] || (_cache[4] = _createElementVNode("p", null, "Before you can continue you'll need to verify your email address.", -1)),
    _createElementVNode("p", null, [
      _cache[0] || (_cache[0] = _createTextVNode(" We should have already sent one do you. If not, you can ")),
      _createElementVNode("a", {
        href: "#",
        class: "default-anchor",
        onClick: _withModifiers(resendMail, ["prevent"])
      }, "request a new mail"),
      _cache[1] || (_cache[1] = _createTextVNode(". "))
    ]),
    (isMailSent.value)
      ? (_openBlock(), _createBlock(Success, { key: 0 }, {
          default: _withCtx(() => [
            _createElementVNode("p", null, "Sent a mail to " + _toDisplayString(_unref(user).email) + ".", 1),
            _createElementVNode("p", null, [
              _cache[2] || (_cache[2] = _createTextVNode("Once you have confirmed it you can ")),
              _createElementVNode("a", {
                href: "#",
                class: "default-anchor",
                onClick: _withModifiers(reload, ["prevent"])
              }, "reload this page"),
              _cache[3] || (_cache[3] = _createTextVNode("."))
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})